<template>
  <heading tag="h3">Autres actions</heading>
  <DisplayGridCards>
    <AccountButton theme="neutral" aspect="4-3" @click="handleShare">
      <template #icon>
        <icon name="share" size="4rem" />
      </template>
      {{ $t('settings.share') }}
    </AccountButton>
    <AccountButton
      theme="neutral"
      aspect="4-3"
      to="https://support.nomadeducation.fr/fr/"
    >
      <template #icon>
        <icon name="faq" size="4rem" />
      </template>
      {{ $t('faq.title') }}
    </AccountButton>
    <AccountButton
      theme="neutral"
      aspect="4-3"
      to="https://support.nomadeducation.fr/fr/"
      target="_blank"
    >
      <template #icon>
        <icon name="tabler:user-question" size="4rem" />
      </template>
      {{ $t('settings.support') }}
    </AccountButton>
    <AccountButton
      v-if="profile.testMember"
      theme="neutral"
      aspect="4-3"
      to="/depatouiller"
    >
      <template #icon>
        <icon name="debug" size="4rem" />
      </template>
      {{ $t('settings.debug') }}
    </AccountButton>
  </DisplayGridCards>
</template>
<script setup lang="ts">
const profile = useProfileStore();

const { handleShare } = useShareNomad();
</script>
